import "./StockModal.scss";
import FormField from "../../../../components/formField/FormField";
import { useState } from "react";
import { useAlert } from "react-alert";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import StockModal from "./StockModal";
import inventoryCountStockItem from "../../../../utility/inventoryCountStockItem";
import { formatQuantity, isDecimalInput } from "../../../../utility/inputValidation";

const ProductLine = ({ label, value }) => (
  <div className="product-line">
    <p className="product-line-label">{label}</p>
    <p className="product-line-value">{value || "-"}</p>
  </div>
);

export default function InventoryModal({ open, onClose, onCreated, product, venueId }) {
  const { t } = useTranslation("stockManagement");
  const alert = useAlert();
  const userStore = useSelector((state) => state.userReducer);
  const [value, setValue] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeModal = () => {
    if (isSubmitting) return;
    setValue("");
    setErrors({});
    onClose();
  };

  const submitHandler = async () => {
    const countedValue = value === "" ? null : Number(value);

    if (!Number.isFinite(countedValue) || countedValue < 0) {
      setErrors({ value: t("inventory_modal_real_quantity_invalid") });
      return;
    }

    try {
      setIsSubmitting(true);
      setErrors({});

      await inventoryCountStockItem({
        stockItemId: product?.id,
        countedValue,
        venueId,
        createdBy: userStore?.users?.uid,
      });

      setValue("");
      await onCreated();
    } catch (error) {
      alert.show(t("inventory_modal_submit_error"), { type: "error" });
      console.error("Error creating inventory count:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StockModal
      open={open}
      onClose={closeModal}
      onConfirm={submitHandler}
      isLoading={isSubmitting}
      title={t("inventory_modal_title", { name: product?.name ? ` - ${product.name}` : "" })}
    >
      <div className="stock-action-modal-products">
        <p className="stock-action-modal-products-subtitle">{t("inventory_modal_subtitle")}</p>
        <ProductLine
          label={t("inventory_modal_line_current_stock")}
          value={formatQuantity(product?.onHand)}
        />
        <FormField
          value={value}
          error={errors.value}
          onChange={(value) => {
            if (isDecimalInput(value)) setValue(value);
          }}
          label={t("inventory_modal_real_quantity")}
        />
      </div>
    </StockModal>
  );
}
